module.exports = __webpack_public_path__ + "static/6-60d0c2496161492aa9ca0b4f3df18f13.jpg";